import Actions from "../actions";

export class StripePaymentMethod {
	cardStyles = {
		base: {
			color: '#32325d',
			lineHeight: '18px',
			fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
			fontSmoothing: 'antialiased',
			fontSize: '16px',
			'::placeholder': {
				color: '#9a9a9a'
			}
		},
		invalid: {
			color: '#fa755a',
			iconColor: '#fa755a'
		}
	};

	stripeActive = false;

	/**
	 *
	 * @param {HTMLInputElement} paymentInput
	 */
	constructor(paymentInput) {
		this.paymentInput = paymentInput;
		this.container = paymentInput.parentElement;
		this.cardElement = this.container.querySelector('.card-element');
		this.errorElement = this.container.querySelector('.card-errors');
		this.form = document.getElementById('checkout-payment');

		this.init();
	}

	init() {
		if (typeof Stripe === 'undefined') {
			throw new Error('Stripe JS API not available');
		}

		const publicKey = this.paymentInput.getAttribute('data-publickey');
		if (!publicKey) {
			throw new Error('Stripe public key not configured');
		}

		// Init Stripe
		this.stripe = Stripe(publicKey);

		this.card = this.stripe.elements().create('card', {
			style: this.cardStyles,
			hidePostalCode: true
		})
	}

	activate() {
		this.stripeActive = true;

		if (this.cardElement.children.length < 1) {
			this.card.mount(this.cardElement);
		}

		this.card.addEventListener('change', (event) => this.onCardChange(event));
		this.form.addEventListener('submit', (event) => this.onSubmit(event));
	}

	deactivate() {
		this.stripeActive = false;
	}

	onCardChange(event) {
		if (!event.error) {
			this.errorElement.innerText = '';
			Actions.refreshSubmit(false, false)
			return;
		}

		this.errorElement.innerText = event.error.message;
	}

	onSubmit(event) {
		if (!this.stripeActive) {
			return;
		}

		event.preventDefault();

		const firstName = document.querySelector('[name="billing_firstname"]').value;
		const lastName = document.querySelector('[name="billing_lastname"]').value;
		const address = document.querySelector('[name="billing_street_address"]').value;
		const city = document.querySelector('[name="billing_city"]').value;
		const postcode = document.querySelector('[name="billing_postcode"]').value;
		const country = document.querySelector('[name="billing_countryId"]').value;

		this.stripe.createToken(this.card, {
			name: `${firstName} ${lastName}`,
			address_line1: address,
			address_city: city,
			address_zip: postcode,
			address_country: country
		}).then((result) => {
			this.errorElement.innerText = '';

			if (result.error) {
				this.cardElement.focus();
				this.errorElement.innerText = result.error.message;
				Actions.refreshSubmit(false, false)
				return;
			}

			let stripeTokenElement = document.querySelector('input[name="stripeToken"]');
			if (stripeTokenElement === null) {
				stripeTokenElement = document.createElement('input');
				stripeTokenElement.setAttribute('type', 'hidden');
				stripeTokenElement.setAttribute('name', 'stripeToken');
				this.form.append(stripeTokenElement);
			}

			stripeTokenElement.setAttribute('value', result.token.id);
			this.form.submit();
		})
	}
}